import { Component, Input, OnInit } from '@angular/core';
import { DateTime } from 'luxon';
import { PromptuarySidebarService } from 'modules/promptuary/services/sidebar/promptuary-sidebar.service';
import { merge } from 'rxjs';
import { PromptuaryService } from 'shared/services/promptuary/promptuary.service';

interface IPendency {
	username: string;
	date: string;
}

interface IPendencies {
	today: IPendency[];
	past: IPendency[];
}

@Component({
	selector: 'promptuary-pendencies',
	templateUrl: './promptuary-pendencies.component.html',
	styleUrls: ['./promptuary-pendencies.component.scss'],
})
export class PromptuaryPendenciesComponent implements OnInit {
	pendencies: IPendencies = {
		today: [],
		past: [],
	};
	isPendenciesLoaded = false;
	isLatePendenciesOpen = true;
	isTodayPendenciesOpen = true;
	isKnowMoreOpen = true;
	@Input() professionalId: string;

	constructor(
		public promptuaryService: PromptuaryService,
		public promptuarySidebarService: PromptuarySidebarService
	) {}

	ngOnInit(): void {
		if (localStorage.getItem('hidePromptuaryKnowMore') === 'true') {
			this.isKnowMoreOpen = false;
		}
		this.getPendencies();
		merge(
			this.promptuarySidebarService.registerObservable,
			this.promptuarySidebarService.noShowObservable
		).subscribe((appointment) => {
			if (appointment) {
				this.getPendencies();
			}
		});
	}

	getPendencies() {
		this.promptuaryService
			.getPromptuaryPendencies()
			.toPromise()
			.then((result) => {
				this.pendencies = result;
				this.isPendenciesLoaded = true;
				if (
					this.pendencies.today?.length > 0 &&
					this.pendencies.past?.length > 0
				) {
					this.isLatePendenciesOpen = false;
				}
			});
	}

	formatDate(date) {
		return `${DateTime.fromISO(date).toFormat(
			'dd/MM/yyyy'
		)} as ${DateTime.fromISO(date).toFormat('HH:mm')}`;
	}

	toogleTab(tab) {
		if (tab === 'late') {
			this.isLatePendenciesOpen = !this.isLatePendenciesOpen;
		} else {
			this.isTodayPendenciesOpen = !this.isTodayPendenciesOpen;
		}
	}

	openSidebar(profileId, appointmentId) {
		this.promptuarySidebarService.openSidebarOrGoToPage(
			profileId,
			appointmentId,
			'promptuary-pendencies'
		);
	}

	closeKnowMore() {
		localStorage.setItem('hidePromptuaryKnowMore', 'true');
		this.isKnowMoreOpen = false;
	}
}
